import { Box, Text, VStack } from '@chakra-ui/react';
import { TitleBar } from '@resistapp/client/components/bars/title-bar';
import { theme } from '@resistapp/client/components/shared/theme';
import { LoadingView } from '@resistapp/client/components/states/loading';
import { useOrganisation, useProjects } from '@resistapp/client/hooks/api';
import { Project } from '@resistapp/common/types';
import { Dictionary, keyBy } from 'lodash';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  OrganisationDetails,
  OrganisationLabWorkbooks,
  OrganisationShipments,
} from '../organisations-view/organisation-row';

export function AdminOrganisationView() {
  const params = useParams();
  const id = Number(params.id);

  const { data: org, isLoading, error: organisationError } = useOrganisation(id);
  const { data: projects, error: projectsError } = useProjects();

  const error = organisationError || projectsError;

  const projectNamesById: Dictionary<Project | null> = useMemo(() => keyBy(projects, 'id'), [projects]);

  if (error) throw error;
  if (isLoading) return <LoadingView />;
  if (!org) {
    return (
      <Box padding={theme.spacing[6]}>
        <Text>Organisation not found.</Text>
      </Box>
    );
  }

  return (
    <div style={{ marginBottom: theme.spacing[16] }}>
      <TitleBar title={`Organisation: ${org.name} (${org.id})`} $extraWide={true} />
      <VStack align="stretch" spacing={4} padding={theme.spacing[4]}>
        <Box padding={2} borderRadius={6} bg="white" boxShadow="sm">
          <OrganisationDetails org={org} projectNamesById={projectNamesById} isExpanded={true} />
        </Box>
        <Box padding={2} borderRadius={6} bg="white" boxShadow="sm">
          <OrganisationLabWorkbooks org={org} />
        </Box>
        <Box padding={2} borderRadius={6} bg="white" boxShadow="sm">
          <OrganisationShipments org={org} />
        </Box>
      </VStack>
    </div>
  );
}
